export enum CategoryOptionsEnum {
  AVATAR = 'AVATAR',
  IMAGE = 'IMAGE',
  FILE = 'FILE',
  EPUB = 'EPUB',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO'
}
